import type { Template } from "@/types";

export const PO_05_H5_V0: Template[] = [
    {
        id: "po-05-h5v0-01",
        name: "PO 01 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 261, width: 286, height: 193, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 462, width: 286, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 341, y: 261, width: 286, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 341, y: 462, width: 286, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 741, y: 261, width: 580, height: 394, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h5v0-02",
        name: "PO 02 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 227, width: 338, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 462, width: 338, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 346, y: 227, width: 338, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 346, y: 462, width: 338, height: 227, rotation: 0, imageRotation: 0 },
            { id: "5", x: 692, y: 227, width: 682, height: 462, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h5v0-03",
        name: "PO 03 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 227, width: 338, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 462, width: 338, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 346, y: 227, width: 682, height: 462, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1036, y: 227, width: 338, height: 227, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1036, y: 462, width: 338, height: 227, rotation: 0, imageRotation: 0 }    
        ],
    },

    {
        id: "po-05-h5v0-04",
        name: "PO 04 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 54, y: 195, width: 580, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 54, y: 597, width: 188, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 250, y: 597, width: 188, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 446, y: 597, width: 188, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 741, y: 261, width: 580, height: 394, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "po-05-h5v0-05",
        name: "PO 05 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 226, width: 687, height: 464, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 94, width: 430, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 815, y: 389, width: 430, height: 287, rotation: 0, imageRotation: 0 },
            { id: "4", x: 815, y: 683, width: 211, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1034, y: 683, width: 211, height: 139, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-06",
        name: "PO 06 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 208, y: 161, width: 286, height: 193, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 362, width: 286, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 352, y: 362, width: 285, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 208, y: 563, width: 286, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 741, y: 261, width: 580, height: 394, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h5v0-07",
        name: "PO 07 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 159, y: 90, width: 370, height: 240, rotation: 0, imageRotation: 0 },
            { id: "2", x: 159, y: 338, width: 370, height: 240, rotation: 0, imageRotation: 0 },
            { id: "3", x: 159, y: 586, width: 370, height: 240, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 90, width: 536, height: 364, rotation: 0, imageRotation: 0 },
            { id: "5", x: 763, y: 462, width: 536, height: 364, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-08",
        name: "PO 08 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 43, y: 256, width: 600, height: 405, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 93, width: 430, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 815, y: 388, width: 211, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1034, y: 388, width: 211, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 815, y: 536, width: 430, height: 287, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h5v0-09",
        name: "PO 09 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 77, y: 244, width: 300, height: 210, rotation: 0, imageRotation: 0 },
            { id: "2", x: 77, y: 462, width: 300, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 385, y: 244, width: 606, height: 428, rotation: 0, imageRotation: 0 },
            { id: "4", x: 999, y: 244, width: 299, height: 210, rotation: 0, imageRotation: 0 },
            { id: "5", x: 999, y: 462, width: 299, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-10",
        name: "PO 10 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 77, y: 134, width: 238, height: 156, rotation: 0, imageRotation: 0 },
            { id: "2", x: 77, y: 298, width: 238, height: 156, rotation: 0, imageRotation: 0 },
            { id: "3", x: 77, y: 462, width: 238, height: 156, rotation: 0, imageRotation: 0 },
            { id: "4", x: 77, y: 626, width: 238, height: 156, rotation: 0, imageRotation: 0 },
            { id: "5", x: 322, y: 134, width: 974, height: 648, rotation: 0, imageRotation: 0 },
        ],
    },
];

